import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

// Function to update or create a srf
export const updateSrf = async (clientId, projectId) => {
  if (!clientId || !projectId) return {};
  try {
    const response = await axios.patch(`/api/srf/${clientId}/${projectId}/`, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Custom hook to update a srf
export default function useUpdateSrf(clientId, projectId) {
  const queryClient = useQueryClient();
  const setSrf = useMutation({
    mutationFn: () => {
      updateSrf(clientId, projectId);
    },
    onError: (err, variables, context) => {
      if (!projectId) return;
      console.log(`Error updating srf: `, err);
    },
    onSettled: (data) => {
      console.log("UPDATE SRF SETTLED: ", data);
      queryClient.invalidateQueries(["srf", clientId, projectId]);
    },
    onSuccess: (data) => {
      console.log("SUCCESSFUL SRF UPDATE: ", data);
    },
  });

  return setSrf;
}
